import { render, staticRenderFns } from "./PopupSalonRating.vue?vue&type=template&id=aa82e05a&scoped=true&"
import script from "./PopupSalonRating.vue?vue&type=script&lang=js&"
export * from "./PopupSalonRating.vue?vue&type=script&lang=js&"
import style0 from "./PopupSalonRating.vue?vue&type=style&index=0&id=aa82e05a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa82e05a",
  null
  
)

export default component.exports